import { lazy } from 'react'
import About from 'src/view/public/About'
import Contact from 'src/view/public/Contact'
import EditorialPolicy from 'src/view/public/EditorialPolicy'
import PrivacyPolicy from 'src/view/public/PrivacyPolicy'
import TermsOfUse from 'src/view/public/TermsOfUse'

const HomePage = lazy(() => import('src/view/home/HomePage'))

const privateRoutes = [].filter(Boolean)

const publicRoutes = [
  {
    path: '/',
    component: <HomePage />,
    allowsAuthenticatedUsers: true,
  },
  {
    path: '/:id',
    component: <HomePage />,
    allowsAuthenticatedUsers: true,
  },
  {
    path: '/about',
    component: <About />,
    allowsAuthenticatedUsers: true,
  },

  {
    path: '/editorial-policy',
    component: <EditorialPolicy />,
    allowsAuthenticatedUsers: true,
  },

  {
    path: '/terms',
    component: <TermsOfUse />,
    allowsAuthenticatedUsers: true,
  },

  {
    path: '/privacy',
    component: <PrivacyPolicy />,
    allowsAuthenticatedUsers: true,
  },
  {
    path: '/contact',
    component: <Contact />,
    allowsAuthenticatedUsers: true,
  },
].filter(Boolean)

const emptyPermissionsRoutes = [].filter(Boolean)

const simpleRoutes = [
  {
    path: '/403',
    loader: () => import('src/view/shared/errors/Error403Page'),
  },
  {
    path: '/404',
    loader: () => import('src/view/shared/errors/Error404Page'),
  },
  {
    path: '/500',
    loader: () => import('src/view/shared/errors/Error500Page'),
  },
  {
    path: '/ApplicationError',
    loader: () => import('src/view/shared/errors/ApplicationErrorPage'),
  },
  {
    path: '*/*',
    loader: () => import('src/view/shared/errors/Error404Page'),
  },
].filter(Boolean)

const routes = {
  privateRoutes,
  publicRoutes,
  emptyPermissionsRoutes,
  simpleRoutes,
}
export default routes
